import SettingUiModal from "./setting-ui-modal.component";

export default SettingUiModal;
